export default __webpack_public_path__ + "static/media/restorations.b4d9fa54.jpg";